export default class CustomerNationalBankModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    // Evita perder código 0 e preserva string (ex: "001"); parseInt(0)||undefined virava undefined
    const raw = obj.bank;
    this.bank = raw != null && raw !== '' ? (parseInt(raw, 10) === 0 ? 0 : (parseInt(raw, 10) || raw)) : undefined;
    this.name = obj.name;
    this.agency = obj.agency;
    this.account = obj.account;
    this.digit = obj.digit;
    this.pix = obj.pix;
    // TED (conta sem chave PIX): tipo da conta e titular
    this.accountType = obj.accountType || null;
    this.holderName = obj.holderName || null;
    this.holderDocument = obj.holderDocument || null;
    this.providerBankAccountId = obj.providerBankAccountId;
    this.isActive = obj.isActive ?? true;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}